import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {GetText} from "../context/text.js";


function Home() {

    let text = GetText();

    return (
        <div>
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>

                        <p>{text.Home.description1}</p>
                        <p>{text.Home.description2}</p>
                        <p>{text.Home.description3}</p>

                        <p>{text.Home.description4} <a href="https://zapauto.com.ua/">zapauto.com.ua</a> {text.Home.description5}</p>

                        <img width="100%" src="https://zapauto.com.ua/download/components/title.webp" alt="title" />

                    </Col>
                </Row>
            </Container>





        </div>
    )
}

export default Home
